import { Stack, TextField, Typography } from '@mui/material'
import { AdvancedMarker, APIProvider, Map } from '@vis.gl/react-google-maps'
import { t } from 'i18next'
import Joi from 'joi'
import { useEffect, useState } from 'react'

import { GOOGLE_MAPS_API_KEY } from '../../../configs/environment.js'
import useFieldValidation from '../../../helpers/fieldValidation.js'

const schema = Joi.object({
  latitude: Joi.number().required(),
  longitude: Joi.number().required()
})

const defaultCenter = {
  lat: 45.745,
  lng: 9.823
}

const containerStyle = {
  width: '100%',
  height: '280px'
}

const UpdatePosition = ({ deviceData, onChange }) => {
  const [updatedPositionData, setUpdatedDeviceData] = useState({
    latitude: defaultCenter.lat,
    longitude: defaultCenter.lng
  })

  useEffect(() => {
    const position = !deviceData.device.position.latitude
      ? {
        latitude: defaultCenter.lat,
        longitude: defaultCenter.lng
      }
      : deviceData.device.position
    setUpdatedDeviceData(position)
  }, [deviceData])

  useEffect(() => {
    const validation = useFieldValidation(updatedPositionData, schema)
    setValidation(validation)
    onChange(updatedPositionData, validation.isValid)
  }, [updatedPositionData])
  const [validation, setValidation] = useState(false)

  const onChangeLatitude = (event) => {
    setUpdatedDeviceData({
      ...updatedPositionData,
      latitude: parseFloat(event.target.value)
    })
  }

  const onChangeLongitude = (event) => {
    setUpdatedDeviceData({
      ...updatedPositionData,
      longitude: parseFloat(event.target.value)
    })
  }

  const handleMapClick = (event) => {
    setUpdatedDeviceData({
      ...updatedPositionData,
      latitude: Math.trunc(event.detail.latLng.lat * 1e7) / 1e7,
      longitude: Math.trunc(event.detail.latLng.lng * 1e7) / 1e7
    })
  }

  return (
    <>
      <Stack
        direction="column"
        spacing={5}
      >
        <Typography
          variant="h2"
          py={1}
        >
          {t('devices.addPosition')}
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-between"
        >
          <TextField
            label={t('common.latitude')}
            name={'latitude'}
            variant="standard"
            type="number"
            value={updatedPositionData.latitude || ''}
            fullWidth
            onChange={onChangeLatitude}
            error={validation?.messages?.latitude?.length > 0}
            helperText={validation?.messages?.latitude?.join(', ')}
          />

          <TextField
            label={t('common.longitude')}
            name={'longitude'}
            variant="standard"
            type="number"
            value={updatedPositionData.longitude || ''}
            fullWidth
            onChange={onChangeLongitude}
            error={validation?.messages?.longitude?.length > 0}
            helperText={validation?.messages?.longitude?.join(', ')}
          />
        </Stack>

        <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
          <Map
            mapId="position-map"
            style={containerStyle}
            defaultZoom={18}
            defaultCenter={{ lat: updatedPositionData.latitude, lng: updatedPositionData.longitude }}
            zoomControl
            onClick={handleMapClick}
            disableDefaultUI
          >
            <AdvancedMarker position={{ lat: updatedPositionData.latitude, lng: updatedPositionData.longitude }}>
            </AdvancedMarker>
          </Map>
        </APIProvider>
      </Stack>
    </>
  )
}

export default UpdatePosition
